import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService, RechargeService } from '@app/core/services';
import { User } from '@app/models/backend';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-recharge-modal',
  templateUrl: './recharge-modal.component.html',
  styleUrls: ['./recharge-modal.component.scss']
})
export class RechargeModalComponent implements OnInit {

  user!: User
  form!: FormGroup;

  submitted: boolean = false;
  success: boolean = false;

  constructor(private fb: FormBuilder,
              private rechargeService: RechargeService,
              private notification: NotificationService,
              private modalRef: BsModalRef) { }

  ngOnInit(): void {
    this.initForm();
  }

  // -- Submit -- //
  submit() {
    const data =
      {
        balance: this.form.value.amount,
        businessId: this.user.businessId,
        isFOC: this.form.value.isFOC,
      };
    let amount = this.form.value.amount;
    this.rechargeService.addBalance(data).subscribe((res: any) => {
      this.submitted = true;
      this.success = true;
      this.notification.success(res['message']);
    }, error => {
      this.notification.error(error['message']);
    });
  }

  // -- Close Modal -- //
  close(): void {
    this.modalRef.hide();
  }

  // -- Init Form -- //
  initForm(): void {
    this.form = this.fb.group({
      amount: ['', Validators.required],
      isFOC: [false, Validators.required]
    });
  }
}
